import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { NotificationManagerService, Notification } from '../notification-manager/notification-manager.service';

/**
 * Component for displaying and managing notifications.
 */
@Component({
  selector: 'terra-notification-viewer',
  templateUrl: './notification-viewer.component.html',
  styleUrls: ['./notification-viewer.component.scss'],
})
export class NotificationViewerComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  /** Array of notifications to be displayed. */
  notifications: Notification[] = [];

  /**
   * Constructor for NotificationViewerComponent.
   * @param notificationService - The service to manage notifications.
   */
  constructor(private notificationService: NotificationManagerService) { }

  /**
   * Lifecycle hook that is called after data-bound properties of a directive are initialized.
   * Subscribes to the notifications observable to update the notifications array.
   */
  ngOnInit(): void {
    this.notificationService.notifications$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      notifications => (this.notifications = notifications)
    );
  }

  /**
   * Dismisses a notification by its Id.
   * @param {Notification} notification - The notification to be dismissed.
   */
  dismissNotification(notification: Notification): void {
    this.notificationService.removeNotification(notification);
  }

  /**
   * Performs the action associated with the notification's call to action.
   * If the notification is dismissible, it also dismisses the notification after performing the action.
   * @param {Notification} notification - The notification for which the action is to be performed.
   */
  performAction(notification: Notification): void {
    notification.cta.action();
    if (notification.dismissible) {
      this.dismissNotification(notification);
    }
  }
}
